
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus(); 
import  ButtonVue from "@/lib/Button.vue";
import CalendarVue from "../calendar/CalendarVue.vue";
import { IdxSvc } from "@/idx/IdxSvc";
import { IIdx } from "@/idx/IIdx";
import { ILbl } from "@/lbl/ILbl";
import { IOrder } from "./IOrder"
import { IAdresOdbiorcy, IOrderSvc, order_api } from "./IOrderSvc"
import { OrderSvc } from "./OrderSvc"
import Store from "@/store/Store";
import { LblSvc } from "../lbl/LblSvc";

import { Next, Route } from 'vue-router';
import { MasterData } from "@/store/MasterData";
@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<OrderVue>) {
            console.log("beforeRouteEnter:", to.path)
            next((vm: OrderVue) => { vm.order_id = to.params.id });
        },
        components: { OrderVue, CalendarVue, ButtonVue} 
})

export default class OrderVue extends Vue {

  lblSvc:LblSvc=new LblSvc()
  nazwy_adresow_odbiorcy = ["TODO"]
  jms:string[] = []
  masterData: MasterData | undefined;

  order_id:any
  order:IOrder|undefined=undefined;
  typy_zlecenia:string[]=[]
  typy_montazu = ["single (A)",  "1+1 (A+B)",  "1perKolumna (A,B,C…)",  "2wCiągu (ABABAB)",  "2+2 (AABB)",  "ksiazeczka",  "peelOff"]

  waluty = ["PLN", "EUR"]

  lbl_id:any;
  adresy_odbiorcy:IAdresOdbiorcy[]=[]

  key=0;
  created() {
    console.log("created")
  }  
  async refresh() {
    this.key++
  }

  
  async mounted() {
    console.log("mounted", this.order_id)

    const masterData: MasterData|undefined =  await (await new Store().getStore()).masterData;
    if (!masterData) return;
    this.typy_zlecenia=masterData.typy_zlecenia
    this.jms = masterData.jm_idn_sel
    const order:IOrder|undefined = await  new OrderSvc().find_by_id(this.order_id); 
    if (!order) { 
      alert("Brak zlecenia"+ this.order_id)
      return;
    } else {
      this.order=order
      console.log("order ok")
    }


    if (!this.order.selected_label) {
      if (this.order.labels.length>0) {
          await this.select_label(this.order.labels[0])
      }
    } else {
      await this.read_lbl(this.order.selected_label)
      await this.refresh()
    }


    if (order.labels.length>1) {
      this.typy_montazu = ["1+1 (A+B)",  "1perKolumna (A,B,C…)",  "2wCiągu (ABABAB)",  "2+2 (AABB)",  "ksiazeczka",  "peelOff"]
    } else {
      this.typy_montazu = ["single (A)"]
    }

    this.key++
  }

  async chg_data_dokumentu(d:Date) {
    if (!this.order) return;
    this.order.data_dokumentu = d;
    await this.chg()
  }

  async chg_data_odbioru(d:Date) {
    if (!this.order) return;
    this.order.data_odbioru = d;
    await this.chg()
  }


  async chg() {
    if (!this.order) return;
    this.order = await new OrderSvc().update_order(this.order)
  }

  async show_lbl(_id:string) {
      window.router.push({ path: `/etykiety/${_id}` }) 
  }

  async select_label(lbl:ILbl) {

    if (await this.read_lbl(lbl)) {
      await this.chg();
      await this.refresh();
    }

  }


  async read_lbl(lbl:ILbl) {

      let changed = true
      if (this.order && this.order.selected_label && this.order.selected_label._id==lbl._id) changed = false

      const ret_lbl=await new LblSvc().find_by_id(lbl._id)
      if (ret_lbl && ret_lbl._id == lbl._id) lbl=ret_lbl;

      if (!this.order) return;
      this.order.selected_label=lbl
      if (!lbl) return;
      
      this.adresy_odbiorcy = await new OrderSvc().get_adresy_odbiorcy(lbl.klient)
      //this.adresy_odbiorcy = await new OrderSvc().get_adresy_odbiorcy("UNILEVER UEBV")
      const ret = await new IdxSvc().find_by_id(lbl._id).catch((err)=>console.log(err));
      
      if (this.order && ret) {
        const idx:IIdx = ret;

        this.order.parent_id = lbl._id;
        
        //this.order.waluta=lbl.w
        this.order.numer_etykiety_u_odbiorcy = lbl.numer_indeksu_u_klienta
        this.order.numer_etykiety_erp = lbl.nr_indeksu
        
        this.order.identyfikator_odbiorcy = lbl.klient
        this.order.data_dokumentu = new Date();
        this.order.data_odbioru = new Date();


        this.order.idn = lbl.klient+'' +idx.nr_indeksu
        if (this.order.zamodb_idm) this.order.idn=this.order.zamodb_idm+" "+this.order.idn
        return true;
      }    
      return false;
    }


 async start_start_flow_montaz() {
    try {
      if (!this.order) return;
      if (!this.order.selected_label) return;
      console.log()
      const ret = await new OrderSvc().start_flow_montaz(this.order)
      console.log(ret)
    } catch (err) {
      console.log(err)
      let e:String="Brakuje jeszcze danych aby rozpocząć montaż.\n"
      e+="Skompletuj dane zlecenia:\n"
      for (let i=0;i<err.messages.length;i++) {
        e+=err.messages[i]+"\n"
      }
      alert(e)
    } 
    
  }


  async nowe_zlecenie_erp() {
    console.log(JSON.stringify(this.order))
    if (!this.order) return;
    try {
      const order = await new OrderSvc().create_nowy_w_erp(this.order)
      if (order) {
        this.order = order;
        alert("Utworzono zlecenie w ERP: "+this.order.zamodb_idm)
        this.key++
      }
    } catch(err) {
      console.log(err)
      let e:String="Błąd w tworzeniu zlecenia\n"
      for (let i=0;i<err.messages.length;i++) {
        e+=err.messages[i]+"\n"
      }
      alert(e)
    }

  }

}
